import script from "./HeaderFeature.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderFeature.vue?vue&type=script&setup=true&lang=js"

import "./HeaderFeature.vue?vue&type=style&index=0&id=4c294547&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c294547"]])

export default __exports__